import axios from 'axios';
import { useState, useEffect, useRef } from 'react';

export default function VideoRow(props) {
    const [videos, setVideos] = useState([]);
    const [mediaFiles, setMediaFiles] = useState({});
    const [activeVideo, setActiveVideo] = useState(null);

    useEffect(() => {
        axios
            .get(`${global.endpoint}wp-json/wp/v2/video?per_page=100&_embed`)
            .then(res => {
                const data = res.data || [];
                setVideos(data);
                setActiveVideo(data[0] || null);

                const idSet = new Set();

                data.forEach(item => {
                    const acf = item?.acf || {};
                    if (acf.fajl && typeof acf.fajl === 'number') { idSet.add(acf.fajl); }
                });

                const ids = Array.from(idSet);
                if (!ids.length) return null;

                return axios.get(`${global.endpoint}wp-json/wp/v2/media?include=${ids.join(',')}`);
            })
            .then(mediaRes => {
                if (!mediaRes) return;
                const map = {};
                (mediaRes.data || []).forEach(m => { map[m.id] = m.source_url; });
                setMediaFiles(map);
            })
            .catch(err => console.error(err));
    }, []);

    if (!videos.length || !activeVideo) return null;

    return (
        <div className={'w-full flex flex-col items-center gap-6 px-site py-16 bg-stone-100 ' + (props.className || '')}>

            <div className='w-full max-w-boxed flex flex-col gap-8'>

                <div className='flex flex-col gap-1'>
                    <div className='text-3xl lg:text-5xl font-bold uppercasre text-stone-600'>Néhány perc velünk</div>
                    <div className='text-stone-400'>Rövid videók, amelyekben a Siloám Református Missziói Otthon arcaival és történeteivel találkozhat</div>
                </div>

                <div className=' flex flex-col lg:flex-row gap-8'>
                    <div className='flex-1 aspect-video'>
                        <VideoPlayer item={activeVideo} mediaFiles={mediaFiles} />
                    </div>

                    <div className='w-full lg:w-auto'>
                        <VideoThumbRow items={videos} mediaFiles={mediaFiles} activeId={activeVideo.id} onSelect={setActiveVideo} />
                    </div>
                </div>

            </div>

        </div>
    );
}

function getMediaUrlFromAcfValue(value, mediaFiles) {
    if (!value) return null;
    if (typeof value === 'number') { return mediaFiles[value] || null; }
    if (typeof value === 'string') { return value; }
    return null;
}

function getVideoData(item, mediaFiles) {
    const acf = item?.acf || {};

    const videoUrl = getMediaUrlFromAcfValue(acf.fajl, mediaFiles);

    return { id: item.id, link: item.link, videoUrl: videoUrl || null };
}

function VideoPlayer({ item, mediaFiles }) {
    const d = getVideoData(item, mediaFiles);

    const src = d.videoUrl || d.link;
    const isDirectFile = src && /\.(mp4|webm|ogg)($|\?)/i.test(src);

    return (
        <div className='w-full h-full overflow-hidden bg-black/5 shadow-md transition-all duration-300 ease-out'>
            {isDirectFile ? (
                <video src={src} controls className='w-full h-full object-cover' />
            ) : (
                <iframe src={src} className='w-full h-full' loading='lazy' />
            )}
        </div>
    );
}

function VideoThumbRow({ items, mediaFiles, activeId, onSelect }) {
    return (
        <div className='w-full flex lg:flex-col gap-2 lg:w-64 h-32 lg:h-full overflow-x-scroll overflow-y-hidden lg:overflow-y-scroll lg:overflow-x-hidden aspect-video pb-2 lg:pb-0 pr-0 lg:pr-2'>

            {items.map(item => (<VideoThumb key={item.id} item={item} mediaFiles={mediaFiles} active={item.id === activeId} onClick={() => onSelect(item)} />))}

        </div>
    );
}

function VideoThumb({ item, mediaFiles, active, onClick }) {
    const d = getVideoData(item, mediaFiles);
    const videoRef = useRef(null);
    const src = d.videoUrl || d.link;

    useEffect(() => {
        const el = videoRef.current;
        if (!el || !src) return;

        const handleLoaded = () => {
            if (!isNaN(el.duration) && el.duration > 0) {
                el.currentTime = el.duration / 2;
            }
        };

        el.addEventListener('loadedmetadata', handleLoaded);
        return () => el.removeEventListener('loadedmetadata', handleLoaded);
    }, [src]);

    return (
        <button
            type='button'
            onClick={onClick}
            className={'aspect-video'}>
            <div className='w-full'>
                <video
                    ref={videoRef}
                    src={src}
                    className='w-full h-full aspect-video object-cover'
                    controls={false}
                    muted
                    playsInline
                    preload='metadata'
                />
            </div>
        </button>
    );
}
